import { ManageAccounts, PersonAddAlt } from '@mui/icons-material';
import { Button } from '@mui/material';

type OrganizationRoleButtonProps = {
  buttonValue: string;
  vacantLabel: string;
  setUserAction: () => void;
  editDateAction: () => void;
};

export const OrganizationRoleButton = (props: OrganizationRoleButtonProps) => {
  const { buttonValue, vacantLabel, setUserAction, editDateAction } = props;
  return (
    <>
      {buttonValue && (
        <Button
          startIcon={<ManageAccounts fontSize='small' />}
          size='small'
          variant='contained'
          color='success'
          disableElevation
          onClick={() => {
            editDateAction();
          }}
        >
          {buttonValue}
        </Button>
      )}
      {!buttonValue && (
        <Button
          startIcon={<PersonAddAlt fontSize='small' />}
          size='small'
          variant='text'
          color='primary'
          disableElevation
          onClick={() => {
            setUserAction();
          }}
        >
          {vacantLabel}
        </Button>
      )}
    </>
  );
};
